var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38015 13.4336L15.3401 3.46338C15.4744 3.32773 15.5807 3.16697 15.6527 2.99023C15.7248 2.8135 15.7613 2.62446 15.7602 2.43359C15.7606 2.04848 15.6097 1.67833 15.3401 1.40332L14.4601 0.533691C14.1872 0.259691 13.8169 0.104884 13.4302 0.103516C13.0439 0.106824 12.6742 0.261336 12.4002 0.533691L0.540186 12.3936C0.270343 12.6725 0.119657 13.0455 0.120142 13.4336C0.119017 13.6245 0.155497 13.8135 0.227564 13.9902C0.299632 14.167 0.405918 14.3277 0.540186 14.4634L12.3902 26.3135C12.5245 26.4502 12.6848 26.559 12.8617 26.6328C13.0386 26.7067 13.2285 26.7443 13.4202 26.7437C13.612 26.7453 13.8021 26.7077 13.9792 26.6338C14.1562 26.5599 14.3164 26.451 14.4501 26.3135L15.3301 25.4434C15.5993 25.1681 15.7501 24.7986 15.7501 24.4136C15.7501 24.0285 15.5993 23.6585 15.3301 23.3833L5.38015 13.4336Z",
    fill: "#131D3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrow);
export default __webpack_public_path__ + "static/media/carousel-arrow.4c3e368a4bada269d0850c92d65918e8.svg";
export { ForwardRef as ReactComponent };